
define(
	'MHI.BasicEnhancements.PLP'
,   [
		'Facets.ItemCell.View',
		'ProductDetails.ImageGallery.View'
	]
,   function (
		FacetsItemCellView,
		ProductDetailsImageGalleryView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var layout = container.getComponent('Layout');
			//SRISD-40 this code gets the url fragment of the category page and adds it to the view context
			layout.addToViewContextDefinition('Facets.CategoryCell.View','urlfrag','string',function(context){
				
				var urlfragment = context.url.split('/');
				urlfragment = urlfragment.pop();
				
				return urlfragment;
			})
			//SRISD-40 end

			//SRISD-45
			_.extend(FacetsItemCellView.prototype, {
				getContext: _.wrap(FacetsItemCellView.prototype.getContext, function (fn) {
					var context = fn.apply(this, _.toArray(arguments).slice(1));
					
					
					context.item = this.model;
					

					return context;
				})
			});

			_.extend(ProductDetailsImageGalleryView.prototype, {
				getContext: _.wrap(ProductDetailsImageGalleryView.prototype.getContext, function (fn) {
					var context = fn.apply(this, _.toArray(arguments).slice(1));
					
					
					context.model = this.model;
					return context;
				})
			});
			//SRISD-45 end
		}
	};
});
